let privacyPolicyJP = require('../privacyPolicy/privacyPolicy_jp')
let ENV = process.env

module.exports = {
  navbar: {
    language: '日本語',
    myAccount: 'アカウント管理',
    setting: '設定',
    signOut: 'サインアウト'
  },
  modal: {
    modalCancel: 'キャンセル',
    modalOk: '確認',
    modalChange: '変更'
  },
  country: {
    jp: '日本',
    cn: '中国'
  },
  status: {
    back: '戻る',
    save: '保存',
    cancel: '取下げ',
    reSubmit: '差戻し',
    receipt: '受付実行',
    rateConfirm: 'レート確定',
    transferred: '送金実行',
    AC: '両替申込済み',
    GU: '取下げ済み',
    WC: 'コイン送金確認中',
    C: '取消済み',
    RA: 'コイン送金確認済み',
    CR: '両替レート確定',
    PC: '送金完了'
  },
  orderInfoModal: {
    title: 'confirm',
    save: 'この両替申請情報を保存しますが、よろしいでしょうか。',
    statusAC: '両替申請資料や送金証跡の見直しをお客様に実施していただきますが、よろしいでしょうか。',
    statusC: 'この両替申請を取消しますと、二度と操作することができませんが、よろしいでしょうか。',
    statusRA: 'コイン送金確認済みのステータスに変更しますが、よろしいでしょうか。',
    statusCR: '両替レートと手数料は下記で決定いたしますが、よろしいでしょうか。',
    statusPC: 'お客様への送金を実行できることを確認できていることでよろしいでしょうか。',
    copperRate: 'Copper Rate',
    rate: '両替レート',
    amount: '金額',
    charge: '手数料',
    operatorMessage: '運営側からの連絡事項',
    status: '申請ステータス',
    successTitle: 'メッセージ',
    successMessage: '申請ステータス変更に成功しました！',
    successButton: '申請一覧に戻る'

  },
  login: {
    welcome: 'おかえりなさい',
    explain: 'サインインしてください。',
    email: 'メールアドレス',
    emailPlaceholder: '会員登録時入力したメールアドレスを入力してください',
    emailRequired: 'メールアドレスを入力してください',
    password: 'パスワード',
    passwordPlaceholder: 'パスワードを入力してください',
    passwordRequired: 'パスワードを入力してください',
    login: 'サインイン',
    signUp: '会員登録',
    signUpText: 'まだアカウントをお待ちでない場合',
    message: 'メールアドレスまたはパスワードが間違えっています'
  },
  forgotPassword: {
    forgotPasswordText: 'パスワードを忘れた場合',
    modalTitle: 'パスワードを忘れた場合',
    message: 'メーセージ',
    sendEmailSuccess: 'Email has been sent to your email. Please check the email to complete password reset.',
    passwordChangeSuccess: 'Password has been changed, please return to the login interface to login.'
  },
  top: {
    mytheme: 'よく利用するメニュー',
    myorder: '両替申請',
    mysettings: '設定',
    Previous: '前',
    Next: '次'
  },
  /**
     * orderHome
     */
  ordertop: {
    myhome: 'ホーム'
  },
  CreateOrder: {
    neworder: '両替の新規申請',
    pointOut: 'お客様のお持ちの仮想通貨をご両替いただけます。現時点で両替先の通貨はUSドルとなります。下記のボタンを押下し、必要な情報をご入力し、両替申請をしてください。',
    createbutton: '新規申請'
  },
  orderList: {
    titleList: '申請リスト',
    textList: '進行中と過去の申請を参照していただけます。',
    listbutton: '申請リスト表示'
  },
  /**
     * OrderCreate
     */
  OrderCreate: {
    OrderCreate: '新規申請',
    Terms: '規約同意',
    Input: '情報入力',
    Confrim: '情報確認',
    Complete: '完了',
    text: '下記の情報を入力して両替を申請できます。画面上に表示しているレート情報は、参考レートとなり、保証できるレートではありません。実際のレートは、申請後にサービス運営担当者よりご連絡いたします。'
  },
  /**
     * OrderCreate-Terms
     */
  OrderTerms: {
    TermsTitle: '「SCALES」利用規約',
    confirmed: '上記のサービス規約を同意する',
    BackButton: '戻る',
    NextButton: '確認',
    CreateButton: '申請'
  },
  /**
    * OrderCreate-Currency
    */
  OrderCurrency: {
    amountOfCurrency: '仮想通貨',
    amountOfCurrencyTips: 'コイン数を入力してください',
    BTC: 'BTC',
    referenceExchangeRate: '参考レート',
    referenceExchangeRateTips: 'こちらに表示しているレートは、参考レートとなります。実際に両替する際のレートと異なります。両替実行までレートが大幅変動する可能性がありますので、目安として確認していただければと思います。',
    budgetEstimate: '想定金額',
    budgetEstimateTips: '参考レートをもとに計算したものとなります。参考レートと同様に、両替実行までレートが大幅変動する可能性がありますので、目安として確認していただければと思います。',
    serviceCharge: '手数料',
    serviceChargeTips: '本サービスを利用する際に発生する手数料となります。',
    traded: '100万USドル相当を超えた両替申請を受付できません。想定金額が100万USドルに収まるようにコイン数を変更してください。'
  },
  /**
     * TwiceVerification
     */
  TwiceVerification: {
    modalSubmit: '送信',
    verificationCodeExplainLogin: 'MFA コードを入力してサインインを完了します。',
    verificationCodeExplainOrder: 'MFA コードを入力して認証を完了します。',
    verificationCodeExplainInfo: 'MFA コードを入力して認証を完了します。',
    twiceVerification: 'MFA 認証',
    verificationCode: 'MFA コード：',
    verificationCodePlaceholder: '認証コードをご入力ください',
    verificationCodeRequired: '認証コードをご入力ください',
    bindAuthenticator: '仮想 MFAデバイスの設定',
    SetVerificationCodeStep1: '仮想 MFAアプリケーションをモバイルデバイスにインストール',
    SetVerificationCodeStep2: '仮想 MFAアプリとデバイスのカメラを使用してQRコードをスキャンします',
    UrlCopy: 'または、シークレットキーを入力することもできます。',
    SetVerificationCodeStep3: 'MFA コードを以下に入力',
    Copy: 'クリップボードにコピー',
    CopySuccess: 'コピーできました'
  },
  /**
     * OrderApplication completed
     */
  ApplicationCompleted: {
    Applicationcompleted: '新規申請を受付けました。',
    pointOut: '両替のご申請、ありがとうございます。仮想通貨の送金先をお客様のメールアドレスへ送信しました。メール内容をご確認し、仮想通貨の送金を実行してください。送金実施後、送金証跡（画面キャプチャとTXID）を登録してください。',
    ReturnButton: '申請一覧へ戻る'
  },
  /**
     * OrderListTOP
     */
  OrderListTop: {
    OrderList: '申請一覧'
  },
  /**
     * OrderList SearchBar
     */
  SearchColumn: {
    NO: '申請番号',
    Status: '申請ステータス',
    All: '全て',
    search: '検索'
  },
  /**
     * All
     */
  AllSearchBar: {
    AC: '両替申込済み',
    GU: '取下げ済み',
    WC: 'コイン送金確認中',
    C: '取消済み',
    RA: 'コイン送金確認済み',
    CR: '両替レート確定',
    PC: '送金完了'
  },
  /**
     * orderList page
     */
  orderlist: {
    AppInfo: '申請情報',
    Transaction: 'コイン送金情報',
    CoinPS: 'コイン送金先アドレス',
    CoinA: 'コイン数',
    CoinTXID: '送金TXID',
    TXIDTips: 'BitCoinを送金する際に、トランザクションIDが生成されます。取引結果画面から該当トランザクションIDをコピーし、ここのテキストボックスへ貼り付けてください。',
    Evidence: '送金証跡（画像）',
    Category: '両替振込先',
    isFairFX: 'サブアカウント',
    notFairFx: 'サブアカウント以外',
    FairFXnum: 'サブアカウント番号',
    FairFXnumTipe: 'サブアカウント番号を入力してください',
    ExchangeRI: '両替レート情報',
    ConfirmCopperRate: 'Determined Copper Rate',
    ConfirmEdexchangeRate: '確定両替レート',
    ConfirmedAmount: '確定両替金額',
    ServiceCharge: '手数料',
    ExchangeRIR: '両替レート情報（申請時）',
    ConfirmEdexchangeRateR: '参考レート',
    ConfirmedAmountR: '想定金額',
    ServiceChargeR: '手数料',
    JP: '日本',
    CN: '中国',
    ContactMatters: '連絡事項',
    Operatormessage: '運営側からの連絡事項',
    Usermessage: 'お客様からの連絡事項',
    USD: 'USD',
    Savebtn: '保存',
    Giveup: '取下げ',
    Request: 'コイン送金確認依頼',
    userInfo: 'お客様情報',
    name: 'お名前',
    email: 'メールアドレス',
    tel: '電話番号',
    copperRateRequired: 'Please input the Determined Copper Rate',
    newRateRequired: '確定両替レートを入力してください',
    mailLanguage: 'メール受信言語',
    limit: '最大1000件を表示しております。',
    lower: '確定両替レートが参考レートの90%を下回っています。このままレート確定処理を行わず、上司へ相談してください。',
    before: '変更前',
    after: '変更後',
    ImgUpload: '画像をアップロード'
  },
  OListinfoxin: {
    fairFX: 'サブアカウント',
    accountHolderNameTips: '口座名義を入力してください',
    myResidenceTips: 'お客様住所を入力してください',
    mycityTips: 'お客様都市を入力してください',
    myPostalCodeTips: 'お客様郵便番号を入力してください',
    accountNumberTips: '口座番号を入力してください',
    bankName: '銀行名を入力してください',
    bankStreet: '銀行住所を入力してください',
    bankCity: '銀行都市を入力してください',
    firstName: 'First Nameを入力してください',
    lastName: 'Last Nameを入力してください',
    bankPostcode: '銀行郵便番号を入力してください',
    bankSWIFT: '銀行SWIFT番号を入力してください'
  },
  /**
     * orderListPopupseven page
     */
  orderListPopup: {
    Confirm: '確認',
    Tips: '申請情報を保存しますが、よろしいでしょうか。',
    Tipsgiup: '両替申請を取下げしますが、よろしいでしょうか。',
    Tipsrequ: 'コイン送金のTXIDと証跡画像をアップロードしますが、よろしいでしょうか。',
    UserMessage: 'お客様からの連絡事項',
    savesuccessful: '申請情報の保存が正常に完了しました。',
    retrunorderList: '申請一覧へ戻る',
    change: '申請ステータスの変更が正常に完了しました',
    Messgae: 'メッセージ',
    uploadFileOut: 'Failed to upload image,Please upload picture below 5MB',
    uploadFileTypeWrong: 'Failed to upload image,Please upload picture',
    Evidence: '送金証跡',
    EvidenceTips: `You can check <a href="${ENV.EVIDENCE}" target="_blank">here</a> to confirm the sample screen capture.`,
    EvidenceIntr: `Please take a screenshot of Transaction ID <br />
    on the following page <br />
    (<a href="https://www.blockchain.com/explorer" target="_blank">https://www.blockchain.com/explorer</a>)`
  },
  /**
     * OrderList DisplayBar
     */
  DisplayBar: {
    Application: '新規申請日時',
    UpdateTime: '更新日時',
    filter: 'フィルター',
    PreviousButton: '前',
    NextButton: '次',
    FirstButton: '最初',
    LastButton: '最後'
  },
  /**
     * SettingsPage
     */
  Settingspage: {
    SettingsTop: '設定',
    UpdateInfo: 'お客様情報変更',
    Tips: 'お客様の基本情報、口座情報、メール受信言語等を変更できます。',
    UpdateButton: '変更',
    UpdatePassword: 'ログインパスワード変更',
    UpdatePsdTips: 'ログインに使うパスワードを変更できます。',
    UpdateTwofactauth: '二要素認証情報変更',
    UpdateTwofactauthTips: '認証アプリの変更、端末紛失等に伴う二要素認証情報を変更できます。'
  },
  /**
     * SettingUpdateInfoPage
     */
  UpdateInfoTop: {
    UpdateInfo: 'お客様情報変更',
    Input: '情報入力',
    Confirm: '情報確認',
    Complete: '完了',
    text: 'お客様の基本情報、口座情報、メール受信言語等を変更できます。'
  },
  /**
    *  Setting UpdateInfoPage Form
    */
  UpdateInfoForm: {
    UserInforTitle: '基本情報',
    MyName: 'お名前',
    MyNameTips: 'お名前を入力してください',
    MyTelephone: '電話番号',
    TelephoneTips: '電話番号を入力してください',
    TelephoneTips1: 'ただしい電話番号を入力してください',
    language: 'メール受信言語',
    FairFX: 'サブアカウント口座情報',
    FairFXNumber: 'サブアカウント番号',
    BankAccount: '銀行口座情報',
    accountHolderName: '口座名義',
    accountHolderNameTips: '口座名義を入力してください',
    myResidence: 'お客様住所',
    mycity: 'お客様都市',
    myPostalCode: 'お客様郵便番号',
    mycountry: 'お客様住居国',
    IBAN: 'User Address',
    accountNumber: '口座番号',
    bankName: '銀行名',
    bankStreet: '銀行住所',
    bankCity: '銀行都市',
    firstName: 'First Name',
    lastName: 'Last Name',
    bankPostcode: '銀行郵便番号',
    bankCountry: '銀行所在国',
    bankSWIFT: '銀行SWIFT番号',
    routing: 'Routing',
    BACS: 'BACS/SEPA',
    Backbtn: '戻る',
    Confirmbtn: '確認',
    Changebtn: '変更'
  },
  /**
     * UpdateInfo Complete Page
     */
  UpdateComplete: {
    Complete: 'お客様情報変更が正常に完了しました。',
    ReturnSettings: '設定画面へ戻る'
  },
  /**
     * Update password Page
     */
  UpdatePasswordPage: {
    UpdatePassword: 'パスワード変更',
    Tips: 'ログインに使うパスワードを変更できます。',
    CurrentPassword: '現在のパスワード',
    ErrorPormpt: '現在のパスワードを入力してください',
    NewsPassword: '新パスワード',
    ErrorPormptnewspad: '新パスワードを入力してください',
    VerifyPassword: '新パスワード（確認）',
    ErrorPormptVerify: '新パスワード（確認）を入力してください',
    notMatch: '新パスワードと新パスワード（確認）が一致しません',
    Cancelbtn: 'キャンセル',
    Changebtn: '変更',
    Updatesucceeded: 'パスワード変更が正常に完了しました'
  },
  RegisterPage: {
    Terms: '利用規約',
    Input: '情報入力',
    Confrim: '情報確認',
    Complete: '完了',
    center: '「SCALES」利用規約',
    Confirm: '利用規約を同意します。',
    Next: '次へ'
  },
  Registerform: {
    UserInforTitle: 'お客様情報',
    Email: 'メールアドレス',
    MyName: 'お名前',
    MyNameTips: 'お名前を入力してください',
    MyTelephone: '電話番号',
    TelephoneTips: '電話番号を入力してください',
    TelephoneTips1: '正しい電話番号を入力してください',
    language: 'メール受信言語',
    FairFX: 'サブアカウント口座情報',
    FairFXNumber: 'サブアカウント番号',
    BankAccount: '銀行口座情報',
    accountHolderName: '口座名義',
    accountHolderNameTips: '口座名義を入力してください',
    myResidence: 'お客様住所',
    mycity: 'お客様都市',
    myPostalCode: 'お客様郵便番号',
    mycountry: 'お客様住居国',
    IBAN: 'User Address',
    accountNumber: '口座番号',
    bankName: '銀行名',
    bankStreet: '銀行住所',
    bankCity: '銀行都市',
    bankPostcode: '銀行郵便番号',
    firstName: 'First Name',
    lastName: 'Last Name',
    bankCountry: '銀行所在国',
    bankSWIFT: '銀行SWIFT番号',
    routing: 'Routing',
    BACS: 'BACS/SEPA',
    successful: '会員登録が正常に完了しました。',
    logininterface: '下のボタンを押下しますと、ログイン画面へ遷移します。',
    Login: 'ログイン',
    Backbtn: '戻る',
    Confirmbtn: '確認',
    Changebtn: '変更',
    Regist: '会員登録'
  },
  languageChoice: {
    English: 'English',
    Japanese: '日本語',
    Chinese: '中文(简体)'
  },
  LandingForm: {
    Email: 'Email',
    Emailplaceholder: 'Enter your email',
    emailTips: 'Please input the correct email address.',
    Password: 'Password',
    Passwordplaceholder: 'Enter your password',
    PasswordTips: 'Please enter your password.',
    Repeatpassword: 'Repeat password',
    Repeatpsdplaceholder: 'Repeat your password',
    RepeatpsdTips: 'Please enter your password again.',
    PsdAndPassword: 'The password and confirm password do not match.',
    Signup: 'Sign up',
    SigninLeft: 'Already have an account? ',
    Signin: 'Sign in',
    TwitterLink: ENV.TWITTER_LINK
  },
  Landing: {
    Scales: 'Scales',
    text1: 'Why increase the',
    text2: 'useless plastic?',
    text3: 'Taking lessons from history <br/> Innovating the Future',
    text4: 'Sustainable Exchange Service',
    tryToService: 'Try the Service'
  },
  LandingCentertext1: {
    textTop1: 'Sustainable Exchange <br/> Service (SES)',
    textTop2: 'Scalesが提供するSustainableExchangeService(SES)はプライバシーが守られる安全なアカウントをユーザーに紹介できるサービスです。',
    Sustainable: 'Sustainable',
    WhereverText: 'By using Sustainable Exchange Service (SES), you can have a trusted account which is protected from country risk.',
    Secure: 'Secure',
    WheneverText: 'Scalesは英国の大手銀行や金融プロバイダーと連携し資金の保全を行っています。',
    Convenience: 'Convenience',
    WhoeverText: 'According to your purpose, you can choose appropriate way to manage your assets. Every operation only needs a few clicks.'
  },
  LandingCentertext2: {
    textTop1: 'Commonly called Crypt <br/> Currency Card',
    textTop2: 'To use exist services, you usually need a complicated procedure such as purchase cards, sign up for the application, install the application, and an expensive initial cost. Besides, services might be terminated unexpectedly because of the change of country regulations. Also, accounts might become unavailable when service card is expired in a few years.'
  },
  LandingCentertext3: {
    textTop1: 'Sustainable Exchange <br/> Service (SES)',
    textTop2: 'Regarding our service, you can sign up only by a few clicks. Your assets is protected in trusted banks so you do not need to worry whether the account is safe, whether the service is available, etc. You can also transfer your currency to any bank account all over the world. Besides, even if the debit card issued by the bank become available, it do nothing to the account. Your whole assets will be 360-degree protected.',
    text1: 'EXCHANGE',
    text2: 'TRANSFER',
    text3: 'Or',
    text4: 'Secure Foreign Account <br/> ※Not Subject to CRS'
  },
  LandingCentertext4: {
    textTop1: 'Secure',
    textTop2: 'Scalesは英国の大手銀行や金融プロバイダーと連携し資金の保全を行っています。'
  },
  LandingCentertext5: {
    textTop1: 'Convenience',
    textTop2: 'Scalesはメールアドレスだけで開設OK <br/> ユーザーの取引量に応じてKYCの提出を求めます'
  },
  LandingCentertext6: {
    textTop1: 'Method 1 (Easy to Start)',
    textTop2: 'Exchange your currency to your own bank',
    textTop3: 'Method 2 (Recommended)',
    textTop4: 'Exchange your currency to your PayGlobal Account',
    text1: 'Easy <br/> Start',
    text2: 'Create an account',
    text3: 'Exchange',
    text4: 'Please tell me your bank <br/> account information.',
    text5: 'Receive cash',
    text6: 'SUBACCOUNT',
    step1: 'STEP ONE',
    step2: 'STEP TWO',
    step3: 'STEP THREE',
    step4: 'STEP FOUR'
  },
  LandingBottom1: {
    Title: 'Who we are',
    Title2: 'working with',
    TitleTips: 'We cooperate with highly trusted bank and financial providers. So you do not need to worry anything about your assets.'
  },
  registSuccess: {
    Title: '会員のご登録、誠にありがとうございます。',
    TitleTips: '本人確認用のメールを送信しました。メールをご確認の上、メールに記載しているリンクを押下し、会員登録を完了させてください。',
    OK: 'OK'
  },
  ClientMessage: {
    timeout: 'ネットワークタイムアウトが発生しました。',
    Request: 'リクエストエラーが発生しました。',
    title: 'メッセージ',
    Retrybtn: 'リトライ',
    Cancelbtn: 'キャンセル',
    OKbtn: 'OK',
    page404: 'ページが見つかりません。',
    page500: '内部エラーが発生しました。',
    Undefinederroe: '定義していないエラーコード：',
    page1001: 'パラメータチェックでエラーが発生しました。',
    page1002: 'ログインが失敗しました。',
    page1003: '未認証のアクセスとなります。ログインしてください。',
    page1004: '処理が失敗しました。',
    page1005: 'ファイルアップロードが失敗しました。',
    page1006: '未認証のアクセスとなります。ログインしてください。',
    page1007: 'タイムアウトが発生しました。再度ログインしてください。',
    page9001: '内部エラーが発生しました。',
    page9002: '不明なエラーが発生しました。(9002)',
    Unknownerror: '不明なエラーが発生しました。',
    login: 'ログイン'
  },
  privacyPolicy: {
    registerPrivacyPolicy: privacyPolicyJP
  }
}



// WEBPACK FOOTER //
// ./src/scripts/consts/i18n/jp.js